import SessionReminderModel from "./session-reminder-model";
import ItemsCollection from "../../gd-model/items-collection";

export default class SessionRemindersCollection extends ItemsCollection{

    constructor(reminders) {
        super();

        this.reset(reminders, false);
    }

    reset(reminders, busEvent = false) {
        this._models = [];
        this._itemsById = {};

        _.map(reminders, reminderJson=>{
            const reminder = new SessionReminderModel(reminderJson);
            this.add(reminder.id, reminder);
        })

        if (busEvent) gd.bus.triggerEvent('gd.session.reminders:reset');
    }

    add(id, item, busEvent = false) {
        super.add(id, item);

        if (busEvent) gd.bus.triggerEvent('gd.session.reminders:add', item);
    }

    remove(id, busEvent = false) {
        super.remove(id);

        if (busEvent) gd.bus.triggerEvent('gd.session.reminders:remove', id);
    }

    update(id, newData, busEvent = false) {
        // we ignore other updates if dont need them
        if (newData.title || newData.scheduleDate || newData.scheduleStatus) {
            const reminder = this.get(id);

            if (!reminder) {
                console.error("ooo... bad case no reminder found in session")
            }

            reminder.update(newData);

            if (busEvent) gd.bus.triggerEvent('gd.session.reminders:update', newData);
        }
    }

    get models() {return this.all()} // for common usage
}